import { api } from '@/scripts/api';

export const MDFAgencyAllocateRequestService = {
    post(accountId, fundRequestId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests/${fundRequestId}/allocate-funds`;

            api.post(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },

    put(accountId, fundRequestId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/fund-requests/vendor-account/${accountId}/requests/${fundRequestId}/allocate-funds`;

            api.put(service, payload)
                .then(resolve)
                .catch(reject);
        });
    },
}
